import styled from 'styled-components'

export const Container = styled.div`
   width: 100%;
`
 
export const Content = styled.article`
    max-width: 1366px;
    margin: 1rem auto;
    width: 95%
`